<template>
    <div id="first" class="container">
        <div class="row" style="margin-top: 15px;">
            <div v-if="curentDist!=null" class="col-xs-2" style="padding-left: 20px;padding-top: 10px;">
                <router-link to="/settings" style="color: black;">
                    <span @click="" style="font-size: 20px;"><i class="ti-arrow-left"></i></span>
                </router-link>
            </div>
            <div class="col-xs-10"  style="padding-top: 10px;">
                <p class="title">Выберите поставщика</p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12" style="padding: 3px;">
                <div class="card">
                    <div class="card-content">
                        <div class="row">
                            <a href="https://1.aki1.ru/#/catalog?add=1">
                            <div class="col-xs-2" style="margin-top: 25px;"><i class="ti-plus"
                                                                               style="font-size: 30px;"></i></div>
                            <div class="col-xs-10"><h4>Добавить</h4></div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<!--        <div class="row" v-for="(d) in  distr" v-bind:key="d.dbase" @click="selectedDistr(d.dbase)">-->
        <div class="row" v-for="(d) in  distr" v-bind:key="d.dbase" >
            <div class="col-xs-12" style="padding: 3px;">
                <div class="card">
                    <div class="card-content">
                        <div class="row">
                            <div class="col-xs-10" @click="dellOrder(d.dbase)">
                                <h4 class="title">{{d.name}}</h4>
                            </div>
                            <div class="col-xs-2" @click="dellDistr(d.dbase)">
                                <i class="ti-trash" style="font-size: 30px;"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

  import swal from 'sweetalert2'

  export default {
    name: 'First',
    data () {
      return {
        distr: null,
        newDistr: null,
        curentDist: null
      }
    },
    mounted () {
      this.curentDist = localStorage.getItem('curentDist')
      // debugger
      this.loadDistr()
    },
    methods: {
      loadDistr () {
        this.$db.distributors.toArray()
        .then((x) => {
          this.distr = x
        })
      },
      selectedDistr () {
        this.$db.order.clear()
        localStorage.curentDist = this.newDistr
        this.$router.push({ name: 'Obmen' })
      },
      dellDistr (dbase) {
        // debugger
        swal({
          title: 'Удалить поставщика??',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false})
          .then((result) => {
            if (result) {
              this.$db.distributors.where('dbase').equals(dbase).delete()
              this.$router.push({ name: 'first' })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      dellOrder (dbase) {
        // debugger
        if (dbase !== this.curentDist) {
          this.newDistr = dbase
          this.$db.order.toArray()
            .then((x) => {
              if (x.length > 0) {
                swal({
                  title: 'Удалить неотправленный заказ?',
                  showCancelButton: true,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  cancelButtonClass: 'btn btn-danger btn-fill',
                  buttonsStyling: false
                }).then((result) => {
                  if (result) {
                    this.selectedDistr()
                  }
                  // eslint-disable-next-line handle-callback-err
                }).catch((error) => {
                  console.log(error)
                })
              } else {
                this.selectedDistr()
              }
            })
        } else {
          this.$router.push({ name: 'Obmen' })
        }
      }
    }

  }

</script>

<style scoped>
    .row {
        margin: 0px;
    }

    a {
        color: #000000;
    }
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Custom/First.vue